import React from "react"
import * as styles from "./WhatsAppButton.module.scss"
import LogoWp from "../../../images/LogoWp.svg"

const WhatsappButton = () => {
    // Número de WhatsApp al que deseas enviar el mensaje
    const phoneNumber = "+5491126726707";

    // Mensaje que se enviará al hacer clic en el enlace
    const message = "Hola, quisiera hacer una consulta.";

    // URL del enlace de WhatsApp
    const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;

    return (
        <div className={styles.WhatsappSection}>
            <div className={styles.MainContainer} data-sal="flip-left" data-sal-delay="800" data-sal-duration="600"  data-sal-easing="ease-out-back">
                <a href={whatsappUrl} target="_blank" rel="noreferrer noopener">
                    <img src={LogoWp} alt="Logo de WhatsApp" />
                </a>
            </div>
        </div>
    );
};

export default WhatsappButton;
